'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentOrganizationInfo(name, address, certificateOfOriginAuthority) {
  this.pI = null;
  this.rZ = null;
  this.Ly = null;
  this.pI = name;
  this.rZ = address;
  this.Ly = certificateOfOriginAuthority;
}
export { $c_Lapp_data_AppDocumentOrganizationInfo as $c_Lapp_data_AppDocumentOrganizationInfo };
$p = $c_Lapp_data_AppDocumentOrganizationInfo.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentOrganizationInfo;
/** @constructor */
function $h_Lapp_data_AppDocumentOrganizationInfo() {
}
export { $h_Lapp_data_AppDocumentOrganizationInfo as $h_Lapp_data_AppDocumentOrganizationInfo };
$h_Lapp_data_AppDocumentOrganizationInfo.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentOrganizationInfo)) {
    if (((this.pI === x$0.pI) && (this.rZ === x$0.rZ))) {
      var x = this.Ly;
      var x$2 = x$0.Ly;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 3;
});
$p.t = (function() {
  return "AppDocumentOrganizationInfo";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.pI;
      break;
    }
    case 1: {
      return this.rZ;
      break;
    }
    case 2: {
      return this.Ly;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "address";
      break;
    }
    case 2: {
      return "certificateOfOriginAuthority";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_AppDocumentOrganizationInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j7)));
}
export { $isArrayOf_Lapp_data_AppDocumentOrganizationInfo as $isArrayOf_Lapp_data_AppDocumentOrganizationInfo };
var $d_Lapp_data_AppDocumentOrganizationInfo = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentOrganizationInfo, "app.data.AppDocumentOrganizationInfo", ({
  j7: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentOrganizationInfo as $d_Lapp_data_AppDocumentOrganizationInfo };
//# sourceMappingURL=app.data.-App-Document-Organization-Info.js.map
